import React from "react";
import { Table } from "@redriver/cinnamon";
import EditInitialScheduleTermModal from "./EditInitialScheduleTermModal";
import RemoveInitialScheduleTermModal from "./RemoveInitialScheduleTermModal";
import MakeInitialScheduleTermLiveModal from "./MakeInitialScheduleTermLiveModal";

const InitialScheduleTermActions = ({
  dealerId,
  item,
  onSubmitted,
  title,
  getAction,
  updateAction,
  deleteAction,
  makeLiveAction,
}) => {
  return (
    <Table.Menu openOnHover>
      <EditInitialScheduleTermModal
        dealerId={dealerId}
        itemId={item.id}
        onUpdated={onSubmitted}
        reference={item.boilerPlateCode}
        getAction={getAction}
        updateAction={updateAction}
        title={title}
      >
        Edit
      </EditInitialScheduleTermModal>
      <RemoveInitialScheduleTermModal
        dealerId={dealerId}
        itemId={item.id}
        onDeleted={onSubmitted}
        reference={item.boilerPlateCode}
        deleteAction={deleteAction}
      >
        Delete
      </RemoveInitialScheduleTermModal>
      {item.isApproved && !item.isLive && (
        <MakeInitialScheduleTermLiveModal
          itemId={item.id}
          dealerId={dealerId}
          onSubmitted={onSubmitted}
          reference={item.boilerPlateCode}
          makeLiveAction={makeLiveAction}
        >
          Make Live
        </MakeInitialScheduleTermLiveModal>
      )}
    </Table.Menu>
  );
};

export default InitialScheduleTermActions;
